// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 16) return "static/js/e6c32c9c6311078e7082.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"70c49171932953af63b0","126":"0b6949d7ebf34433a82c","127":"8543d1e2959b7c93fe78"}[chunkId] + ".chunk.js";
};